// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format24 } from '../../constants';

/** Jordan */
const JO: PhoneNumberData = [962, 'JO', 9, format24];

export default JO;
